import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const imgContentGrid = {
  init() {
    this.$sections = document.querySelectorAll('section.image_content_grid .menu_wrapper');
    this.swipers = [];

    if (this.$sections && this.$sections.length) {
      this.destroyBinded = this.destroy.bind(this);
      this.resizeHandlerBinded = this.resizeHandler.bind(this);
      this.setUpListeners();
      this.setUpStickyMenus();
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);
    window.addEventListener('resize', this.resizeHandlerBinded);
  },

  lastWidth: window.innerWidth,
  resizeTimeout: null,
  resizeHandler() {
    if (this.lastWidth !== window.innerWidth) {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.destroyStickyMenus();
        this.setUpStickyMenus();
      }, 300);
    }
  },

  setUpStickyMenus() {
    this.$sections.forEach($menu => {
      ScrollTrigger.create({
        id: 'stikcy_menu',
        trigger: $menu,
        pin: true,
        pinSpacing: false,
        start: 'top top',
        end: (document.documentElement.scrollHeight - window.innerHeight) + 'px top',
        onEnter() {
          $menu.classList.add('active');
        },
        onLeaveBack() {
          $menu.classList.remove('active');
        },
        // markers: true
      });
    });
  },

  destroyStickyMenus() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'stikcy_menu') {
        trigger.kill();
        console.log('Destroying stikcy_menu triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroy() {
    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
    window.removeEventListener('resize', this.resizeHandlerBinded);
    this.destroyStickyMenus();
  }
};

PubSub.subscribe('page.inDOM', imgContentGrid.init.bind(imgContentGrid));

export default imgContentGrid;
